<style lang="less">
    @import "../../../styles/common.less";
</style>
<template>
    <div class="evidenceInfo">
        <div class="evidenceInfo-top" style="height:787px">
            <div class="evidenceInfo-top-title" style="margin-bottom:0px">存证详情</div>
            <ul class="cert-info-ul">
                <li>
                    <span style="width:185px;margin-left:30px">存证名称：</span>
                    <span class="span-right">{{showList.orderTitle}}</span>
                </li>
                <li>
                    <span style="width:185px;margin-left:30px">区块链联盟公示：</span>
                    <span class="span-right">{{showList.publicHash?showList.publicHash:'-'}}</span>
                </li>
                <li>
                    <span style="width:185px;margin-left:30px">存证数据包校验值：</span>
                    <span class="span-right">{{showList.zipHash?showList.zipHash:'-'}}</span>
                </li>
                <li>
                    <span style="width:185px;margin-left:30px">校验算法：</span>
                    <span class="span-right">SHA256</span>
                </li>
                <li>
                    <span style="width:185px;margin-left:30px">存证数量：</span>
                    <span class="span-right">{{showList.attachmentsNum?showList.attachmentsNum:0}}个文件</span>
                </li>
                <li>
                    <span style="width:185px;margin-left:30px">提交存证时间：</span>
                    <span class="span-right">{{showList.createDate}}</span>
                </li>
                <li>
                    <span style="width:185px;margin-left:30px">存证证书下发时间：</span>
                    <span class="span-right">{{showList.evidenceArchiveCertTime?showList.evidenceArchiveCertTime:'-'}}</span>
                </li>
            </ul>
            <h2>存证附件展示：</h2>
            <div class="img-list common-scroll-style">
                <ul class="img-list-ul">
                    <li v-for="(item,index) in showArray" :key="index">
                        <img :src="item.attachmentUrl" class="cert-lists-img" alt="存证证书"/>
                        <p class="notwrap">{{item.attachmentName}}</p>
                    </li>

                </ul>
            </div>
            <h2 style="display: inline-block;"
                v-if="showList.orderAuditStatus=='reject_editable'||showList.orderAuditStatus=='reject'">驳回原因：</h2>
            <div style="display: inline-block;color:#f00"
                 v-if="showList.orderAuditStatus=='reject_editable'||showList.orderAuditStatus=='reject'">
                {{showList.orderAuditReason?showList.orderAuditReason:''}}
            </div>
        </div>
        <div class="evidenceInfo-top" v-if="showList.orderAuditStatus=='cert_sign_issue'" style="min-height:357px">
            <div class="evidenceInfo-top-title">存证证书</div>
            <div class="evidence-content">
                <div class="evidence-bottom">
                    <div style="width:166px;margin-right:20px"><img src="@/assets/cert-img.png" alt='版权登记'/></div>
                    <div class="evidence-bottom-right">
                        <p class="p-one">{{showList.orderTitle?showList.orderTitle+'-':''}}存证证书 </p>
                        <ul class="evidence-bottom-ul">
                            <li>
                                <span style="width:70px">证书状态：</span>
                                <span>已认证</span>
                            </li>
                            <li>
                                <span style="width:70px">证书编号：</span>
                                <span>{{showList.evidenceArchiveCertNumber}}</span>
                            </li>
                            <li>
                                <span style="width:70px">核验单位：</span>
                                <span>中国科学院国家授时中心、北京天威诚信电子商务服务有限公司、版权区块链联盟</span>
                            </li>
                            <li>
                                <span style="width:70px">认证日期：</span>
                                <span>{{showList.evidenceArchiveCertTime?showList.evidenceArchiveCertTime.split(' ')[0]:''}}</span>
                            </li>
                        </ul>
                        <div>
                            <button class="btn-76" @click="openVerify">证书核验</button>
                            <button class="btn-76" @click="downBook(showList.orderSeqNo)" style="margin:0px 15px">下载证书
                            </button>
                            <button class="btn-76" @click="downDataBook(showList.orderSeqNo)" style="width:126px;margin:0px 15px 0 0">下载存证数据包
                            </button>
                            <button class="btn-76" v-if="showList.orderAuditStatus=='cert_sign_issue'" @click="downBcBook(showList.orderSeqNo)" style="width:100px">下载BC文件
                            </button>
                        </div>
                    </div>
                </div>
                <div class="evidence-bottom-tsc">
                    <img src="@/assets/tsc_img.png" alt='版权登记'/>
                    <div class="evidence-bottom-tsc-content">
                        <p class="p-one">{{showList.orderTitle?showList.orderTitle+'-':''}}可信时间凭证认证证书 </p>
                        <ul class="evidence-bottom-tsc-content-ul">
                            <li>
                                <span>签发单位：</span>
                            </li>
                            <li>
                                <span>
                                    中国科学院国家授时中心<br/>
                                    西安可信时间认证服务有限公司
                                </span>
                            </li>
                        </ul>
                        <div>
                            <button class="btn-76" @click="openTscVerify"> 查看证书</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="evidenceInfo-top" style="min-height:357px" v-if="showList.insurance && showList.insurance.insuranceStatus == 1">
            <div class="evidenceInfo-top-title">存证保险</div>
            <div class="evidence-bottom">
                <div style="width:166px;margin-right:20px"><img src="../insurance/images/baoxian.png" alt='版权登记'/></div>
                <div class="evidence-bottom-right">
                    <p class="p-one">{{showList.orderTitle?showList.orderTitle+'-':''}}存证保险 </p>
                    <ul class="evidence-bottom-ul">
                        <li>
                            <span style="width:70px">保单状态：</span>
                            <span>{{showList.insurance.insuranceStatus == 1 ? "已生效":""}}</span>
                        </li>
                        <li>
                            <span style="width:70px">保险编号：</span>
                            <span>{{showList.insurance.policyNo}}</span>
                        </li>
                        <li>
                            <span style="width:100px">投保保险公司：</span>
                            <span>国任保险</span>
                        </li>
                        <li>
                            <span style="width:88px">保险有效期：</span>
                            <span>{{showList.insurance.startDate}}至{{showList.insurance.endDate}}</span>
                        </li>
                    </ul>
                    <div>
                        <button class="btn-76" @click="baodanVerify">保单核验</button>
                        <button class="btn-76" @click="downInsurance(showList.insurance.policyUrl)" style="margin:0px 15px">下载保单
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 证书核验码 -->
        <verifycode @fatherModal="fatherModal" v-show="showModal" ref="childModal" :flag='flag'
                    :orderSeqNo='orderSeqNo'></verifycode>
    </div>
</template>

<script>
    import {bqjUrl} from "@/config/config"
    import verifycode from '../verification/verifyCode';

    const reImg = /^(bmp|BMP|png|PNG|jpg|JPG|gif|GIF|jpeg|JPEG)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;
    export default {
        metaInfo: {
            title: '存证详情|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '存证详情,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "certInfo",
        components: {
            verifycode
        },
        data() {
            return {
                total: 10,
                showList: {},
                showArray: [],
                showModal: !1,
                flag: '0',
                orderSeqNo: "",
                music: require('@/assets/music_icon.png'),
                text: require('@/assets/text_icon.png'),
                video: require('@/assets/video_icon.png'),
                other: require('@/assets/file_icon.png'),
                bqjUrlTh: bqjUrl
            }
        },
        methods: {
            downBcBook(id) {
                window.open(this.API_ROOT_UPLOAD + "bqjvip/blockChain/tianPing/downloadBc?certificateOrderSeqNos=" + id, '_self');
            },
            showMessage() {
                let id = this.$route.query.id;
                let _this = this;
                this.getRequest("/orderCommon/get/" + id).then(res => {
                    console.log('++++++++++++++++++++++++++', res)
                    if (res.code == 200) {
                        _this.showList = res.result;
                        let middleArray = res.result.attachments;
                        for (let i = 0; i < middleArray.length; i++) {
                            let layout = middleArray[i].attachmentUrl.substring(middleArray[i].attachmentUrl.lastIndexOf('.') + 1)
                            if (reImg.test(layout)) {
                              console.log(middleArray[i].attachmentUrl.substring(0,5))
                              if(middleArray[i].attachmentUrl && middleArray[i].attachmentUrl.substring(0,5) == 'https'){
                                middleArray[i].attachmentUrl = middleArray[i].attachmentUrl + '?x-image-process=image/resize,m_fixed,w_274,h_154'
                              }
                              else{
                                let httpsImg = '';
                                httpsImg = this.bqjUrlTh + '/bqjvip/file/downLoad?fileUrl=' + middleArray[i].attachmentUrl;
                                middleArray[i].attachmentUrl = httpsImg
                              }
                            } else if (reMusic.test(layout)) {
                                middleArray[i].attachmentUrl = _this.music;
                            } else if (reText.test(layout)) {
                                middleArray[i].attachmentUrl = _this.text;
                            } else if (reVideo.test(layout)) {
                                middleArray[i].attachmentUrl = _this.video;
                            } else {
                                middleArray[i].attachmentUrl = _this.other;
                            }

                        }
                        _this.showArray = middleArray;
                        // _this.showArray = res.result.attachments;
                        _this.orderSeqNo = res.result.orderSeqNo;
                    }
                })
            },
            downBook(id) {
                this.getRequest("/orderCommon/downloadCert/" + id).then(res => {
                    if (res.code == 200) {
                        window.open(res.result, '_blank')
                        // this.funDownload(res.result)
                    }
                })
            },
            //下载保单
            downInsurance(url) {
                window.open(url, '_blank')
            },
            downDataBook(id) {
                console.log(this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id);
                window.open(this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id, '_blank');
            },
            fatherModal() {
                let _this = this;
                _this.showModal = !1;
            },
            baodanVerify() {
               window.open("http://www.guorenpcic.com/web/bdyz/index.jhtml", '_blank');
            },
            openVerify() {
                // let _this = this;
                // _this.showModal = !0;
                let routeUrl = this.$router.resolve({
                    path: "/index/creation_verification",
                    name: 'creationVerification',
                    params: {type: this.flag, id: this.orderSeqNo}
                });
                window.open(routeUrl.href, '_blank');
                // window.open( this.API_ROOT_UPLOAD + "/index/creation_verification/" + this.flag+'/'+this.orderSeqNo, '_blank');
            },
            openTscVerify() {
                 window.open( this.bqjUrlTh + "/bqjvip/tsc/certByOrderSeqNo?orderSeqNo=" +this.orderSeqNo, '_blank');
            }
        },
        mounted() {
            this.showMessage()
        }
    };
</script>
<style scoped lang="less">
    .cert-info-ul {
        overflow: hidden;

        li {
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            padding: 17px 0px;
            display: flex;
            box-sizing: border-box;
            border-bottom: 1px solid #F1F1F1;

            .span-right {
                flex: 1;
                word-break: break-all;
            }
        }

        li:nth-child(odd) {
            background: rgba(252, 252, 252, 1);
        }
    }

    h2 {
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
        font-weight: 400;
        line-height: 20px;
        margin: 20px 30px;
    }

    .img-list {
        height: 210px;
        margin-left: 30px;
        overflow: auto;

        .img-list-ul {
            overflow: hidden;

            li {
                float: left;
                height: 190px;
                margin-right: 20px;
                margin-bottom: 20px;
                list-style: none;
                position: relative;

                .cert-lists-img {
                    width: 274px;
                    height: 154px;
                    margin-bottom: 10px;
                }

                .cert-lists-icon {
                    position: absolute;
                    width: 24px;
                    height: 24px;
                    top: 10px;
                    left: 10px;
                }

                .dci-tip {
                    width: 274px;
                    height: 34px;
                    line-height: 34px;
                    background: rgba(255, 255, 255, 1);
                    opacity: 0.8;
                    position: absolute;
                    bottom: 36px;
                    left: 0;
                    text-indent: 7px;
                    font-size: 12px;
                    color: #3A3A3A;
                }

                p {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(102, 102, 102, 1);
                    line-height: 20px;
                    width: 274px;
                }
            }
        }
    }
</style>
